import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Card = styled.div`
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
  animation: ${fadeIn} 0.3s ease forwards;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  padding-top: 66.67%;
  overflow: hidden;
  background-color: #f7f7f7;
`;

export const Image = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
`;

export const HeartButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: ${p => p.$active ? '#ef4444' : '#ffffff'}; /* vermelho quando ativo */
  border: none;
  cursor: pointer;
  z-index: 2;
  width: 38px;
  height: 38px;
  padding: 0;
  display: grid;
  place-items: center;
  border-radius: 9999px; /* garante círculo perfeito */
  line-height: 0; /* evita deslocamentos por linha */
  transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 6px 16px rgba(0,0,0,0.18);
  border: 1px solid ${p => p.$active ? 'rgba(239,68,68,0.35)' : 'rgba(0,0,0,0.08)'};

  svg {
    width: 18px;
    height: 18px;
    color: ${p => p.$active ? '#ffffff' : '#5A3E2B'}; /* branco quando ativo, marrom quando inativo */
    transition: transform 0.2s ease, color 0.2s ease;
    filter: none;
  }

  &:hover {
    background: ${p => p.$active ? '#dc2626' : '#ffffff'}; /* vermelho mais escuro no hover quando ativo */
    transform: scale(1.06);
    box-shadow: 0 8px 18px rgba(0,0,0,0.2);
  }

  &:hover svg {
    color: ${p => p.$active ? '#ffffff' : '#3E2A1F'}; /* mantém contraste no hover */
  }
`;

export const Content = styled.div`
  padding: 16px 12px;
`;

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 500;
  color: #222222;
  margin: 0 0 6px 0;
  line-height: 1.3;
  /* Garante que todos os cards tenham a mesma altura reservando 2 linhas para o título */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: calc(1.3em * 2);
`;

export const Location = styled.p`
  font-size: 14px;
  color: #717171;
  margin: 0 0 8px 0;
`;

export const Summary = styled.p`
  font-size: 13px;
  color: #555;
  margin: 0 0 12px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: calc(1.4em * 2);
`;

export const Details = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 12px 0;
  color: #717171;
  font-size: 14px;
`;

export const DetailItem = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #717171;
  
  svg {
    width: 18px;
    height: 18px;
    color: #717171;
  }
`;

export const Price = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #222222;
  margin-top: 12px;
  
  span {
    font-weight: 400;
    font-size: 14px;
    color: #717171;
  }
`;

export const Tag = styled.span`
  position: absolute;
  top: 16px;
  left: 16px;
  background: #BA824F;
  color: white;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  z-index: 2;
  letter-spacing: 0.5px;
`;

export const HoverActions = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  gap: 16px;
  opacity: 0;
  transition: opacity 0.3s ease;

  ${ImageContainer}:hover & {
    opacity: 1;
  }

  button {
    /* Botão circular com fundo escuro e ícone centralizado */
    border: none;
    color: white;
    font-size: 20px;
    width: 44px;
    height: 44px;
    border-radius: 9999px; /* círculo perfeito */
    cursor: pointer;
    transition: transform 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
    background: rgba(0, 0, 0, 0.78);
    display: grid;
    place-items: center;
    line-height: 0;
    box-shadow: 0 6px 14px rgba(0,0,0,.25);

    &:hover {
      transform: scale(1.08);
      background: rgba(0, 0, 0, 0.9);
      box-shadow: 0 8px 18px rgba(0,0,0,.28);
    }

    svg {
      width: 22px;
      height: 22px;
    }
  }
`;